import { MessagesSquare } from 'lucide-react';

import type { MainActionButtonType } from '../types/MainActionButtonViewModel';

/**
 * Default leading icon for a main action button, derived from its `type`.
 * Community Channels has one; Subscribe / Message Me don't. Callers override it
 * with the view model's `leftIcon` when set.
 */
export function MainActionButtonIcon({
  type,
  color,
}: {
  type: MainActionButtonType;
  color: string;
}) {
  if (type === 'community-channels') {
    return <MessagesSquare className="h-4 w-4" style={{ color }} aria-hidden />;
  }
  return null;
}
